import React from 'react';
import Paper from '@material-ui/core/Paper';
import { Redirect } from 'react-router-dom';
import HOCLoader from '../HOC/HOCLoader.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import { injectIntl } from 'react-intl';
import DeleteAlert from '../Alert/DeleteAlert.jsx';
import { NotificationManager } from 'react-notifications';
import { ChatList } from 'react-chat-elements';
import { SITE_URL } from '../../utils/config/constants.js';

class MessageInbox extends React.Component {
    constructor(props) {
        super();
        this.state = {};
    }

    render() {
        return (
            <div>
                <div className="col-md-4">
                    <Paper>
                        <ChatList
                            className="chat-list"
                            dataSource={[
                                {
                                    avatar: { SITE_URL },
                                    alt: 'Reactjs',
                                    title: 'Facebook',
                                    subtitle: 'What are you doing?',
                                    date: new Date(),
                                    unread: 0,
                                },
                                {
                                    avatar: { SITE_URL },
                                    alt: 'Reactjs',
                                    title: 'Facebook',
                                    subtitle: 'What are you doing?',
                                    date: new Date(),
                                    unread: 0,
                                },
                                {
                                    avatar: { SITE_URL },
                                    alt: 'Reactjs',
                                    title: 'Facebook',
                                    subtitle: 'What are you doing?',
                                    date: new Date(),
                                    unread: 0,
                                },
                            ]}
                        />
                    </Paper>
                </div>
                <div className="col-md-8">
                    <Paper>
                        <ChatList
                            className="chat-list"
                            dataSource={[
                                {
                                    avatar: { SITE_URL },
                                    alt: 'Reactjs',
                                    title: 'Facebook',
                                    subtitle: 'What are you doing?',
                                    date: new Date(),
                                    unread: 0,
                                },
                                {
                                    avatar: { SITE_URL },
                                    alt: 'Reactjs',
                                    title: 'Facebook',
                                    subtitle: 'What are you doing?',
                                    date: new Date(),
                                    unread: 0,
                                },
                                {
                                    avatar: { SITE_URL },
                                    alt: 'Reactjs',
                                    title: 'Facebook',
                                    subtitle: 'What are you doing?',
                                    date: new Date(),
                                    unread: 0,
                                },
                            ]}
                        />
                    </Paper>
                </div>
            </div>
        );
    }
}

// const composedComponent = compose(
//     connect(
//         null,
//         actions
//     )
// );

export default MessageInbox;



// WEBPACK FOOTER //
// ./src/components/Customer/MessageInbox.jsx